// extracted by mini-css-extract-plugin
export default {"notFound":"style_notFound__7Jj3s","gradient2":"style_gradient2__nKr8G","gradient1":"style_gradient1__PDK-U","mainContent":"style_mainContent__opUga"};